import { showDialog } from '../reducers/app';
import { get_any_transmitter_id } from '../util/definitions';
import { initialState, setEditScheduleDialog } from '../reducers/edit_schedule_dialog';
export function newSchedule(device_id) {
    return (dispatch, getState) => {
        const { definitions } = getState();
        if (device_id == undefined) {
            device_id = get_any_transmitter_id(definitions);
            if (device_id == undefined) {
                return;
            }
        }
        const init = Object.assign(Object.assign({}, initialState), { transmitter_id: device_id });
        dispatch(setEditScheduleDialog(init));
        dispatch(showDialog('schedule-edit'));
    };
}
